import { Component } from '@angular/core';
import { GetMaterialItemParams } from '../material-item.component';
import { StateService } from '@app/core/services/state.service';

@Component({
    selector: 'tt-material-item-view',
    templateUrl: './material-item-view.component.html',
    styleUrls: ['./material-item-view.component.css'],
})
export class MaterialItemViewComponent {
    public params: GetMaterialItemParams;

    constructor(private state: StateService) {
        this.params = state.getStateParams() as unknown as GetMaterialItemParams;
    }

    public onSubmit() {
        this.state.back();
    }
}
